import React from "react";
import { Context } from "../../../Helpers/Auth";
import { useHistory } from "react-router-dom";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";

import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import DashboardGraphics from "../DashboardGraphics_obs";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";

function DashboardCards(params) {
  // const history = useHistory();
  const { t } = useTranslation();
  return (
    <>
      <div className="h-full w-full mb-10 ">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 p-4 gap-4">
          <div className="bg-blue-500 dark:bg-gray-800 shadow-lg rounded-[8px] flex items-center justify-between p-3 border-b-4 border-blue-600 dark:border-gray-600 text-white font-medium group">
            <div className="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">
              <RequestQuoteOutlinedIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
            </div>
            <div className="text-right">
              <p>{t("negociosFechados")}</p>
              <p className="text-2xl">1,257€</p>
            </div>
          </div>
          <div className="bg-blue-500 dark:bg-gray-800 shadow-lg rounded-[8px] flex items-center justify-between p-3 border-b-4 border-blue-600 dark:border-gray-600 text-white font-medium group">
            <div className="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">
              <WorkOutlineOutlinedIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
            </div>
            <div className="text-right">
              <p>{t("ultimoMes")}</p>
              <p className="text-2xl">557€</p>
            </div>
          </div>
          <div className="bg-blue-500 dark:bg-gray-800 shadow-lg rounded-[8px] flex items-center justify-between p-3 border-b-4 border-blue-600 dark:border-gray-600 text-white font-medium group">
            <div className="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">
              <HandshakeOutlinedIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
            </div>
            <div className="text-right">
              <p>{t("negociosRealizados")}</p>
              <p className="text-2xl">11,257€</p>
            </div>
          </div>
          <div className="bg-blue-500 dark:bg-gray-800 shadow-lg rounded-[8px] flex items-center justify-between p-3 border-b-4 border-blue-600 dark:border-gray-600 text-white font-medium group">
            <div className="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">
              <PaidOutlinedIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
            </div>
            <div className="text-right">
              <p>{t("valorMedioNegocio")}</p>
              <p className="text-2xl">75,257€</p>
            </div>
          </div>
        </div>

        <DashboardGraphics />
      </div>
    </>
  );
}

export default DashboardCards;
